import { render, staticRenderFns } from "./disapprove-dialog.vue?vue&type=template&id=3815cea4&"
import script from "./disapprove-dialog.vue?vue&type=script&lang=js&"
export * from "./disapprove-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports